var React = require('react');

function IcArrowSoft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.8933 30.4226C17.0034 32.3125 13.772 30.974 13.772 28.3013V5.24257C13.772 2.56985 17.0034 1.23136 18.8933 3.12125L30.4227 14.6506C31.5942 15.8222 31.5942 17.7217 30.4227 18.8933L18.8933 30.4226Z","fill":"white"}));
}

IcArrowSoft.defaultProps = {"viewBox":"0 0 33 33","fill":"none"};

module.exports = IcArrowSoft;

IcArrowSoft.default = IcArrowSoft;
